import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { LOGIN_REACHIQ_LOGO } from "../../utils/constants/assets";
import { styles } from "./styles";
import {
  confirmPasswordvalidation,
  passwordValidation,
  domainValidation,
} from "../../utils/validations";
import { Anchor, RightsTag } from "../../components";
import { useSelector } from "react-redux";

import {
  authEndpoints,
  PRIVACY_POLICY_LINK,
  TERMS_SERVICE_LINK,
} from "../../utils/constants/httpConstants";
import { useNavigate } from "react-router-dom";
import { SIGNUP_PATH } from "../../utils/constants/routes";
import EventEmitter from "../../utils/emitter/EventEmitter";
import { EMITTER_ERROR, EMITTER_SUCCESS } from "../../utils/constants";
import { axios } from "../../config";
import Typography from "../../components/Typography/Typography";
import { fontWeight, ICON_LABELS } from "../../utils/constants/UI";
import { STRINGS } from "./strings";
import { GREY } from "../../utils/constants/colors";
import Button from "../../components/Buttons/Button";
import InputField from "../../components/InputFields/InputField";
import Image from "../../image/Image";

const GoogleSignupScreen = () => {
  const classes = styles();
  const navigate = useNavigate();
  const googleAuthUserDetailsSelector = useSelector(
    (state) => state.googleAuthUserDetails
  );
  const name =
    googleAuthUserDetailsSelector?.payload?.first_name +
    " " +
    googleAuthUserDetailsSelector?.payload?.last_name;
  const email = googleAuthUserDetailsSelector?.payload?.owner_email;

  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [passwordType, setPasswordType] = useState(STRINGS.password);
  const [confirmPasswordType, setConfirmPasswordType] = useState(
    STRINGS.password
  );
  const [confirmPassword, setConfirmPassword] = useState("");
  const [domain, setDomain] = useState("");
  const [validations, setValidations] = useState({
    password: "",
    domain: "",
    confirmPassword: "",
  });
  const togglePassword = () => {
    if (passwordType === STRINGS.password) {
      setPasswordType(STRINGS.TEXT);
      return;
    }

    setPasswordType(STRINGS.password);
  };

  const toggleConfirmPassword = () => {
    if (confirmPasswordType === STRINGS.password) {
      setConfirmPasswordType(STRINGS.TEXT);
      return;
    }

    setConfirmPasswordType(STRINGS.password);
  };
  const handleDomain = (e) => {
    setDomain(e.target.value);
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validatedDomain = domainValidation(domain);
    const validatedPassword = passwordValidation(password);
    const validatedComfirmPassword = confirmPasswordvalidation(
      password,
      confirmPassword
    );
    if (
      validatedDomain.isValid &&
      validatedPassword.isValid &&
      validatedComfirmPassword.isValid
    ) {
      setErrors({});
      setValidations({ password: "", domain: "", confirmPassword: "" });
      // Create Try Catch block here to register user.
      try {
        setLoading(true);
        const payload = {
          sub_domain: domain,
          password: password,
          token: googleAuthUserDetailsSelector?.payload?.token,
        };
        const response = await axios.post(authEndpoints.googleSignup, payload);
        EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
        const URL = "https://" + response?.data?.data?.tenant_url;
        const anchor = document.createElement("a");
        anchor.href = URL;
        anchor.click();
      } catch (error) {

        if(error?.response?.data?.data?.errors !==""){
          setErrors(error?.response?.data?.data?.errors);

        }else{
          EventEmitter.emit(EMITTER_ERROR, error?.response?.data?.message || "Something went wrong!")

        }
      } finally {
        setLoading(false);
      }
    } else {
      setErrors({
        domain: validatedDomain.message,
        password: validatedPassword.message,
        confirmPassword: validatedComfirmPassword.message,
      })
      setValidations({
        domain: validatedDomain.message,
        password: validatedPassword.message,
        confirmPassword: validatedComfirmPassword.message,
      });
    }
  };

  useEffect(() => {
    if (!googleAuthUserDetailsSelector?.payload) {
      EventEmitter.emit(EMITTER_ERROR, STRINGS.PLEASE_REGISTER);
      navigate(SIGNUP_PATH);
    }
  }, [googleAuthUserDetailsSelector, navigate]);

  return (
    <Box className={classes.container}>
      <Box className={classes.leftContainer}>
        <div className={classes.containLogo}>
          <Image src={LOGIN_REACHIQ_LOGO} className={classes.logo} />
          <div className={classes.top}>
            <Typography
              label={STRINGS.LETS_GET_FAMILIAR}
              color={GREY.PRIMARY}
              size={"dxs"}
              fontWeight={fontWeight.SEMIBOLD}
            />
          </div>
          <div className={classes.tops}>
            <Typography
              label={STRINGS.TO_GET_STARTED}
              color={GREY.SECONDARY}
              size={"sm"}
              fontWeight={fontWeight.REGULAR}
            />
          </div>
        </div>
        {/* Main auth form here */}
        <Box component="div">
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <Box className={classes.Gapped}>
              <Box className={classes.WiDTH}>
                <Box className={classes.FOUR}>
                  <Typography
                    size={"sm"}
                    color={GREY.QUATINARY}
                    fontWeight={fontWeight.MEDIUM}
                    label={STRINGS.FIRST_NAME}
                  />
                </Box>
                <Box className={classes.WiDTH}>
                  <InputField
                    placeholder={STRINGS.ENTER_FIRTNAME}
                    size={"md40"}
                    value={name.split(" ")[0]}
                    variant={"disabled"}
                    disabled={true}
                  />
                </Box>
              </Box>
              <Box className={classes.WiDTH}>
                <Box className={classes.FOUR}>
                  <Typography
                    size={"sm"}
                    color={GREY.QUATINARY}
                    fontWeight={fontWeight.MEDIUM}
                    label={STRINGS.LAST_NAME}
                  />
                </Box>

                <Box className={classes.WiDTH}>
                  <InputField
                    placeholder={STRINGS.ENTER_LASTNAME}
                    size={"md40"}
                    value={name.split(" ")[1]}
                    variant={"disabled"}
                    disabled={true}
                  />
                </Box>
              </Box>
            </Box>

            <Box className={classes.FOUR}>
              <Typography
                size={"sm"}
                color={GREY.QUATINARY}
                fontWeight={fontWeight.MEDIUM}
                label={STRINGS.EMAIL}
              />
            </Box>
            <InputField
              placeholder={STRINGS.ENTER_EMAIL}
              size={"md40"}
              value={email}
              variant={"disabled"}
              disabled={true}
            />

            <Box className={classes.WiDTH}>
              <Box className={classes.FOURs}>
                <Typography
                  size={"sm"}
                  color={GREY.QUATINARY}
                  fontWeight={fontWeight.MEDIUM}
                  label={STRINGS.SUB_DOMAIN}
                />
              </Box>
            </Box>
            <Box className={classes.FOUR}>
              <InputField
                variant={errors?.sub_domain ? STRINGS.ERROR : STRINGS.DEFAULT}
                errormessage={
                  errors?.sub_domain
                    ? errors?.sub_domain
                    : "" || validations.domain
                      ? validations.domain
                      : ""
                }
                placeholder={STRINGS.ENTER_DOMAIN}
                size={"md40"}
                value={domain}
                onChange={(e) => {
                  handleDomain(e);
                  setValidations({ ...validations, domain: "" });
                }}
                isDomain
              />
            </Box>
            <Box className={classes.Head}>
              <Box className={classes.WiDTHs}>
                <Box className={classes.FOUR}>
                  <Typography
                    size={"sm"}
                    color={GREY.QUATINARY}
                    fontWeight={fontWeight.MEDIUM}
                    label={STRINGS.PASSWORD}
                  />
                </Box>
                <InputField
                  variant={errors?.password ? STRINGS.ERROR : STRINGS.DEFAULT}
                  errormessage={
                    errors?.password
                      ? errors?.password
                      : "" || validations.password
                        ? validations.password
                        : ""
                  }
                  placeholder={STRINGS.ENTER_PASSWORD}
                  size={"md40"}
                  value={password}
                  RightIcon={
                    passwordType === STRINGS.password
                      ? ICON_LABELS.VISIBILITY_OFF
                      : ICON_LABELS.VISIBILITY_ON
                  }
                  rightOnClick={() => togglePassword()}
                  onChange={(e) => {
                    handlePassword(e);
                    setValidations({ ...validations, password: "" });
                  }}
                  type={passwordType}
                />
              </Box>
              <Box className={classes.WiDTHs}>
                <Box className={classes.FOUR}>
                  <Typography
                    size={"sm"}
                    color={GREY.QUATINARY}
                    fontWeight={fontWeight.MEDIUM}
                    label={STRINGS.CONFIRM_PASSWORD}
                  />
                </Box>
                <InputField
                  variant={
                    errors?.confirm_password ? STRINGS.ERROR : STRINGS.DEFAULT
                  }
                  errormessage={
                    errors?.confirm_password
                      ? errors?.confirm_password
                      : "" || validations.confirmPassword
                        ? validations.confirmPassword
                        : ""
                  }
                  size={"md40"}
                  placeholder={STRINGS.ENTER_CONFIRM_PASSWORD}
                  value={confirmPassword}
                  onChange={(e) => {
                    handleConfirmPassword(e);
                    setValidations({ ...validations, confirmPassword: "" });
                  }}
                  RightIcon={
                    confirmPasswordType === STRINGS.password
                      ? ICON_LABELS.VISIBILITY_OFF
                      : ICON_LABELS.VISIBILITY_ON
                  }
                  rightOnClick={() => toggleConfirmPassword()}
                  type={confirmPasswordType}
                />
              </Box>
            </Box>
            <Box className={classes.containLoginBtn}>
              <Button
                size={"sm36"}
                variant={"primary"}
                label={STRINGS.SIGNUP}
                isLoading={loading}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      {/* Main auth form here */}
      <div className={classes.contains}>
        <div className={classes.containPolicy}>
          <RightsTag className={classes.termsPara} />
          <Anchor
            href={PRIVACY_POLICY_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            <div className={classes.hovering}>
              <Typography
                size={"xs"}
                color={GREY.SECONDARY}
                fontWeight={fontWeight.SEMIBOLD}
                label={STRINGS.PRIVACY}
              />
            </div>
          </Anchor>
          <div className={classes.TypoHead}>
            <Typography
              size={"xs"}
              color={GREY.TERTIARY}
              fontWeight={fontWeight.MEDIUM}
              label={STRINGS.AND}
            />{" "}
          </div>
          <Anchor
            href={TERMS_SERVICE_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            <div className={classes.hovering}>
              <Typography
                size={"xs"}
                color={GREY.SECONDARY}
                fontWeight={fontWeight.SEMIBOLD}
                label={STRINGS.TERMS}
              />
            </div>
          </Anchor>
        </div>
      </div>
    </Box>
  );
};

export default GoogleSignupScreen;
